import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Field } from "react-final-form";
import { MultipleTextInput } from "@vk-hr-tek/ui/input";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleTextInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleTextInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const MultipleTextInput_MultipleTextInput = (t0)=>{
    const $ = c(34);
    let id;
    let label;
    let labelIcon;
    let name;
    let onChange;
    let placeholder;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let testId;
    let tooltip;
    let type;
    if ($[0] !== t0) {
        ({ id, name, type, label, labelIcon, placeholder, max: t1, onChange, tooltip, showError: t2, required: t3, disabled: t4, loading: t5, testId } = t0), rest = _object_without_properties(t0, [
            "id",
            "name",
            "type",
            "label",
            "labelIcon",
            "placeholder",
            "max",
            "onChange",
            "tooltip",
            "showError",
            "required",
            "disabled",
            "loading",
            "testId"
        ]);
        $[0] = t0;
        $[1] = id;
        $[2] = label;
        $[3] = labelIcon;
        $[4] = name;
        $[5] = onChange;
        $[6] = placeholder;
        $[7] = rest;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = testId;
        $[14] = tooltip;
        $[15] = type;
    } else {
        id = $[1];
        label = $[2];
        labelIcon = $[3];
        name = $[4];
        onChange = $[5];
        placeholder = $[6];
        rest = $[7];
        t1 = $[8];
        t2 = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
        testId = $[13];
        tooltip = $[14];
        type = $[15];
    }
    const max = void 0 === t1 ? 3 : t1;
    const showError = void 0 === t2 ? true : t2;
    const required = void 0 === t3 ? false : t3;
    const disabled = void 0 === t4 ? false : t4;
    const loading = void 0 === t5 ? false : t5;
    let t6;
    if ($[16] !== disabled || $[17] !== id || $[18] !== label || $[19] !== labelIcon || $[20] !== loading || $[21] !== max || $[22] !== onChange || $[23] !== placeholder || $[24] !== required || $[25] !== showError || $[26] !== testId || $[27] !== tooltip || $[28] !== type) {
        t6 = (t7)=>{
            const { input, meta } = t7;
            const values = Array.isArray(input.value) ? [
                ...input.value
            ] : [];
            const handleChange = (index, value)=>{
                values[index] = value;
                input.onChange(values);
                if (onChange) onChange(values);
            };
            return /*#__PURE__*/ jsx(MultipleTextInput, _object_spread_props(_object_spread({}, input), {
                id: id,
                testId: testId,
                label: label,
                labelIcon: labelIcon,
                required: required,
                disabled: disabled,
                values: values,
                onChange: handleChange,
                type: type,
                error: meta.touched && !!meta.error,
                helperText: showError && meta.touched && meta.error,
                placeholder: placeholder,
                tooltip: tooltip,
                max: max,
                loading: loading
            }));
        };
        $[16] = disabled;
        $[17] = id;
        $[18] = label;
        $[19] = labelIcon;
        $[20] = loading;
        $[21] = max;
        $[22] = onChange;
        $[23] = placeholder;
        $[24] = required;
        $[25] = showError;
        $[26] = testId;
        $[27] = tooltip;
        $[28] = type;
        $[29] = t6;
    } else t6 = $[29];
    let t7;
    if ($[30] !== name || $[31] !== rest || $[32] !== t6) {
        t7 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({
            name: name
        }, rest), {
            children: t6
        }));
        $[30] = name;
        $[31] = rest;
        $[32] = t6;
        $[33] = t7;
    } else t7 = $[33];
    return t7;
};
export { MultipleTextInput_MultipleTextInput as MultipleTextInput };
